import Icon from '@ant-design/icons';
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';

const LogoSvg = () => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.7546 4H10C6.68629 4 4 6.68629 4 10V18C4 21.3137 6.68629 24 10 24H18C21.3137 24 24 21.3137 24 18V15.2454C22.6304 16.3433 20.8919 17 19 17C14.5817 17 11 13.4183 11 9C11 7.10811 11.6567 5.3696 12.7546 4ZM0 10C0 4.47715 4.47715 0 10 0H18C23.5228 0 28 4.47715 28 10V18C28 23.5228 23.5228 28 18 28H10C4.47715 28 0 23.5228 0 18V10ZM19 13C16.7909 13 15 11.2091 15 9C15 6.79086 16.7909 5 19 5C21.2091 5 23 6.79086 23 9C23 11.2091 21.2091 13 19 13Z"
      fill="#1677FF"
    />
  </svg>
);

export const LogoIcon = (props: Partial<CustomIconComponentProps>) => <Icon component={LogoSvg} {...props} />;
